// extracted by mini-css-extract-plugin
export default {"root":"xuT3sGUfBD8m0zxRRCri","contentArea":"jrn2O6DMNY491Z69T00g"};